'use client';

import { useTranslations } from 'next-intl';
import { FeatureDetailContent } from './FeatureDetailContent';
import {
    Key,
    Shield,
    Lock,
    CreditCard,
    Clock,
    Globe
} from 'lucide-react';

export function EPinContent() {
    const t = useTranslations('ePin');

    const features = [
        {
            icon: Key,
            title: t('features.step1.title'),
            description: t('features.step1.description'),
        },
        {
            icon: Shield,
            title: t('features.step2.title'),
            description: t('features.step2.description'),
        },
        {
            icon: Lock,
            title: t('features.step3.title'),
            description: t('features.step3.description'),
        },
        {
            icon: CreditCard,
            title: t('features.step4.title'),
            description: t('features.step4.description'),
        },
        {
            icon: Clock,
            title: t('features.step5.title'),
            description: t('features.step5.description'),
        },
        {
            icon: Globe,
            title: t('features.step6.title'),
            description: t('features.step6.description'),
        },
    ];

    const benefits = t.raw('benefits.list') as string[];

    return (
        <FeatureDetailContent
            pageKey="e-pin"
            translationNamespace="ePin"
            features={features}
            benefits={benefits}
            ctaIcon={Key}
            showWhatIsBitcoin={true}
            introImageSrc="/images/features/E-pin.webp"
            introImageAlt={t('intro.imageAlt') || 'E-PIN Integration in MLM Software'}
            introParagraphKeys={['paragraph1', 'paragraph2']}
            introSectionHeadingPage="e-pin"
            introSectionHeadingTitle={t('intro.sectionHeadingTitle') || 'About E-PIN Integration'}
            introSectionHeadingPill={t('intro.sectionHeadingPill') || 'E-PIN Integration'}
            useLocaleContent={true}
        />
    );
}

